import {WordCloudWrapper} from 'views/storyboard/charts/wordcloud/WordCloudWrapper';

export default WordCloudWrapper;
